import { APPLICATION } from "@/constants";

type OnlineExclusiveBannerProps = {
  onlineExclusiveBannerLabel?: string;
  background?: string;
  className?: string;
  dataTestid?: string;
  noBorder?: boolean;
  fontWeight?: number;
};

function OnlineExclusiveBanner({
  onlineExclusiveBannerLabel = "Online Exclusive Price",
  background,
  className,
  dataTestid,
  noBorder = false,
  fontWeight = 500,
}: Readonly<OnlineExclusiveBannerProps>) {
  return (
    <div
      style={{
        background,
        fontWeight: APPLICATION === "renewal" ? 600 : fontWeight,
      }}
      className={`w-fit h-[24px] justify-center text-[12px] px-spacing-xs py-spacing-xxs rounded-lg  ${
        noBorder ? "" : "border-[1px] border-[#d3e0fe]"
      } text-surface-neutral-option-1 flex items-center leading-[16px] ${className}`}
    >
      <div data-testid={dataTestid}>{onlineExclusiveBannerLabel}</div>
    </div>
  );
}

export default OnlineExclusiveBanner;
